import { useState } from "react";
import SectionHead from "./SectionHead";
import { SCENES, SCENE_ZONES } from "../../../mocks/chigua";

export default function SceneZones() {
  const [zone, setZone] = useState("all");
  const list = zone === "all" ? SCENES : SCENES.filter((s) => s.zone === zone);

  return (
    <section id="scene" className="scroll-mt-24 bg-foreground-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col gap-4 mb-7">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 border-b-2 border-accent-500 pb-3">
            <div>
              <div className="flex items-center gap-3 mb-2">
                <span className="font-heading text-2xl font-black text-accent-400 leading-none">04</span>
                <span className="text-[11px] tracking-[0.3em] text-accent-300 uppercase">Field · 现场直击</span>
                <span className="h-px flex-1 bg-background-50/15 hidden sm:block" />
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-black text-background-50">抓奸实录 · 吃瓜现场分区</h2>
            </div>
            <a href="#quote" className="inline-flex items-center gap-1 text-xs text-background-100/70 hover:text-accent-300 whitespace-nowrap">
              去槽点墙看更多 <i className="ri-arrow-right-s-line" />
            </a>
          </div>
          <p className="text-sm text-background-100/70 leading-relaxed max-w-3xl">
            按发生地分成六个现场分区，封面卡统一「监控视角」美术。挑一个离你最近、或最抓眼的现场，进去就看围观群众怎么接话。
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2 mb-6">
          {SCENE_ZONES.map((z) => (
            <button
              key={z.key}
              onClick={() => setZone(z.key)}
              className={
                "inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm transition-colors whitespace-nowrap " +
                (zone === z.key
                  ? "bg-accent-500 text-foreground-950 font-medium"
                  : "bg-background-50/10 text-background-100/80 hover:bg-background-50/20")
              }
            >
              <i className={z.icon} /> {z.name}
            </button>
          ))}
          <span className="ml-auto text-xs text-background-100/60 hidden md:inline">当前 {list.length} 个现场在播</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {list.map((s) => (
            <article key={s.id} className="group rounded-lg overflow-hidden border border-background-50/10 bg-background-50/5 hover:border-accent-500/50 transition-colors flex flex-col">
              <div className="relative overflow-hidden h-44">
                <img
                  src={s.cover}
                  alt={`抓奸实录吃瓜现场 ${s.title}`}
                  title={`抓奸实录评论区 ${s.title}`}
                  className="h-full w-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute left-2 top-2 inline-flex items-center gap-1 rounded-sm bg-black/50 text-background-50 px-2 py-0.5 text-[11px] whitespace-nowrap">
                  <i className="ri-vidicon-line text-accent-400" /> 现场
                </span>
                {s.badge && (
                  <span className="absolute right-2 top-2 rounded-sm bg-accent-500 text-foreground-950 px-1.5 py-0.5 text-[10px] whitespace-nowrap">
                    {s.badge}
                  </span>
                )}
              </div>
              <div className="flex flex-1 flex-col p-4">
                <span className="text-[11px] tracking-wider text-accent-300 whitespace-nowrap">{s.zone === "hotel" ? "酒店现场" : s.zone === "elevator" ? "电梯楼道" : s.zone === "parking" ? "停车场" : s.zone === "home" ? "家中对质" : "街头撞见"}</span>
                <h3 className="mt-2 text-[15px] font-semibold leading-snug text-background-50 line-clamp-2">{s.title}</h3>
                <p className="mt-2 text-xs text-background-100/70 leading-relaxed line-clamp-2">{s.summary}</p>
                <div className="mt-auto pt-4 flex items-center justify-between">
                  <div className="flex items-center gap-3 text-[11px] text-background-100/60">
                    <span className="inline-flex items-center gap-1"><i className="ri-chat-3-line" /> {s.comments}</span>
                    <span className="inline-flex items-center gap-1"><i className="ri-eye-line" /> {s.views}</span>
                  </div>
                  <span className="inline-flex items-center gap-1 text-xs text-accent-400 group-hover:gap-2 transition-all whitespace-nowrap">
                    围观 <i className="ri-arrow-right-s-line" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}